import messages from './messages_ja';
import labels from './labels_ja';

export default {
  hello: 'こんにちは!!',
  messages,
  labels
};
